<template>
  <div id="about">
    <div class="text_box">
      <div class="content">
        <h2>欢迎光临我的个人站点</h2>
        <p>欢迎来到我的个人站点。在这里我分享了一些我的摄影作品和一些随笔文章，内容会不定期进行更新。</p>
        <p>个人平时从事计算机IT方向的事务，但同时喜爱摄影，故创建了这个站点来将自己的作品和想法分享给互联网。</p>
        <a href="/blog/hello_world">了解下这个站点的建设背景</a>
        <hr>
        <h4>联系我</h4>
        <p>邮箱: corvusnest@live.com</p>
        <h4>支持我</h4>
        <p>若有需要的云服务商, 使用下列邀请码或链接可使我们双方获得优惠和返利</p>
        <p>Digital Ocean <a href="https://m.do.co/c/c9c4fbf43867">邀请链接</a></p>
        <hr>
        <h4>版权声明</h4>
        <p>站内所有摄影作品均出自本人拍摄。未经许可严禁冒名盗用或商业使用。</p>
        <a rel="license" href="http://creativecommons.org/licenses/by-nc-nd/4.0/"><img alt="知识共享许可协议" style="border-width:0" src="https://i.creativecommons.org/l/by-nc-nd/4.0/88x31.png" /></a><br />本站作品采用<a rel="license" href="http://creativecommons.org/licenses/by-nc-nd/4.0/">知识共享署名-非商业性使用-禁止演绎 4.0 国际许可协议</a>进行许可。
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'about',
  data () {
    return {
    }
  },
  methods: {
  },
  created: function () {
    this.$store.dispatch('changeIndex', {linkName: 'about'});
  },
}
</script>

<style lang="scss" scoped>

  $font-color: #5E5E5E;
  $background-color: #F5F5F5;
  $blog-left-color: #EDEDED;

  a {
    color: $font-color;
  }
  .text_box {
    margin: 30px 50px;
    padding: 10px;
    background-color: $background-color;
    color: $font-color;
  }
  .content {
    line-height: 1.5em;
    max-width: 786px;
    margin: 40px auto;
  }
  @media screen and (max-width: 767px) {
    .text_box {
      margin: 10px;
    }
    .content {
      margin: 20px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/about.vue